/**
 * "Open in our browser" — a globe button for vendor/customer records.
 * Hands the URL to the Browser tab (sessionStorage + event, then ?tab=browser).
 * Users without browser access get the site in a real tab instead.
 */
import { createContext, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Globe } from "lucide-react";

export const BrowserAccessContext = createContext(false);
export const PENDING_KEY = "elite-browser-open";

export const normalizeSite = (u) => {
  const t = (u || "").trim();
  if (!t) return "";
  return /^https?:\/\//i.test(t) ? t : `https://${t}`;
};

export const OpenInBrowserButton = ({ url, name, testid, className = "" }) => {
  const enabled = useContext(BrowserAccessContext);
  const [, setSearchParams] = useSearchParams();
  const target = normalizeSite(url);
  if (!target) return null;
  const open = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!enabled) { window.open(target, "_blank", "noopener"); return; }
    sessionStorage.setItem(PENDING_KEY, target);
    window.dispatchEvent(new CustomEvent(PENDING_KEY, { detail: { url: target } }));
    setSearchParams((prev) => { const p = new URLSearchParams(prev); p.set("tab", "browser"); return p; }, { replace: false });
  };
  return (
    <button type="button" onClick={open} data-testid={testid} aria-label={`Open ${name || "website"} in browser`}
      title={enabled ? `Open ${target} in the app browser` : `Open ${target}`}
      className={`rounded p-1.5 text-[#2c6eeb] hover:bg-blue-50 ${className}`}>
      <Globe className="h-3.5 w-3.5" />
    </button>
  );
};
